import React from 'react';
import styled from 'styled-components';

const StyledMobileBlock = styled.div<Props>`
  display: ${({ hideForMobile }) => (hideForMobile ? 'none' : 'block')};
  @media screen and (min-width: 600px) {
    display: ${({ hideForMobile }) => (hideForMobile ? 'block' : 'none')};
  }
`;

interface Props {
  hideForMobile: boolean;
}

export const MobileBlock: React.FC<Props & React.HTMLAttributes<HTMLDivElement>> = (props) => {
  return <StyledMobileBlock {...props} />;
};
